import notificationStore from "../store/notificationStore";
import {getCountNoti, getListNoti} from "../network/notiApi";

export const fetchNotification = async (params) => {
  const {setNotification} = notificationStore.getState();
  try {
    const response = await getListNoti(params);
    if (response?.success || response?.status === 200) {
      setNotification({
        items: response?.items,
        total: response?.total,
        page: response?.page,
        size: response?.size,
      });
    }
    return response;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};

export const fetchCountNoti = async (params) => {
  const {setCountNoti} = notificationStore.getState();
  try {
    const response = await getCountNoti(params);
    if (response?.success || response?.status === 200) {
      setCountNoti(response);
    }
    return response;
  } catch (error) {
    console.error("Failed to fetch services", error);
  }
};
